import type { searchFlights } from 'api/flights'
import { CHARTER_FLIGHT_DETAILS } from 'constants/charterFlight'
import { CHARTER } from 'constants/provider'

type CharterSeasonSearchOptions = Pick<Parameters<typeof searchFlights>[0], 'occupancies' | 'fareClass' | 'currency' | 'email' | 'allowIncompleteJourneys'> & {
  charterBundleRoute: App.CharterBundleRoute
}

/** Build seasonal inventory parameters; callers own pricing, caching and request side effects. */
export function getCharterSeasonSearchParams({ charterBundleRoute, ...params }: CharterSeasonSearchOptions) {
  const route = CHARTER_FLIGHT_DETAILS[charterBundleRoute]
  return {
    ...params,
    itinerary: [{
      departureAirport: route.originAirport.airportCode ?? '',
      arrivalAirport: route.destinationAirport.airportCode ?? '',
      departureDate: route.dateRange.min,
    }, {
      departureAirport: route.destinationAirport.airportCode ?? '',
      arrivalAirport: route.originAirport.airportCode ?? '',
      departureDate: route.dateRange.max,
    }],
    source: CHARTER,
  }
}
